export const PAYOUT_HISTORY_ROUTES = {
  LIST: '/payout-history',
} as const;
